// extracted by mini-css-extract-plugin
export default {"hideBtn":"styles_hideBtn__ePNP3","hiddenState":"styles_hiddenState__HravH"};